import { render, staticRenderFns } from "./hospitalStatisticsChild.vue?vue&type=template&id=d7292d64&scoped=true&"
import script from "./hospitalStatisticsChild.vue?vue&type=script&lang=js&"
export * from "./hospitalStatisticsChild.vue?vue&type=script&lang=js&"
import style0 from "./hospitalStatisticsChild.vue?vue&type=style&index=0&id=d7292d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7292d64",
  null
  
)

export default component.exports